//// ERROR

export function truncateString(value, maxLength = 500)
{
    if (typeof value !== 'string') return value
    if (value.length <= maxLength) return value
    return `${value.slice(0, maxLength)}... [truncated ${value.length - maxLength} chars]`
}

export function serializeValue(value, depth = 0, seen = new WeakSet())
{
    if (value === null || value === undefined) return value

    const valueType = typeof value
    if (valueType === 'string') return truncateString(value)
    if (valueType === 'number' || valueType === 'boolean') return value
    if (valueType === 'bigint') return value.toString()
    if (valueType === 'function') return `[Function ${value.name || 'anonymous'}]`
    if (value instanceof Error) return serializeError(value, depth + 1, seen)

    if (depth >= 3) {
        if (Array.isArray(value)) return `[Array(${value.length})]`
        return `[${value?.constructor?.name || 'Object'}]`
    }

    if (Array.isArray(value)) {
        return value.slice(0, 10).map(item => serializeValue(item, depth + 1, seen))
    }

    if (valueType === 'object') {
        if (seen.has(value)) return '[Circular]'
        seen.add(value)

        const serialized = {}
        const keys = Object.keys(value).slice(0, 20)
        for (const key of keys) {
            serialized[key] = serializeValue(value[key], depth + 1, seen)
        }
        return serialized
    }

    return String(value)
}

export function serializeError(error, depth = 0, seen = new WeakSet())
{
    if (!error) return null

    const serialized = {
        name: error?.name || null,
        message: error?.message || String(error),
        status: error?.status ?? null,
        stack: truncateString(error?.stack || null, 4000)
    }

    if (error?.cause !== undefined) {
        serialized.cause = serializeValue(error.cause, depth + 1, seen)
    }

    const ownPropertyNames = Object.getOwnPropertyNames(error)
    const excluded = new Set(['name', 'message', 'stack', 'cause'])
    const details = {}

    for (const key of ownPropertyNames) {
        if (excluded.has(key)) continue
        details[key] = serializeValue(error[key], depth + 1, seen)
    }

    if (Object.keys(details).length > 0) {
        serialized.details = details
    }

    return serialized
}